namespace $ { $mol_style_attach( "shm/projects/codex/prompt/prompt.view.css",
 "[shm_projects_codex_prompt_edit] {\n\tcolor: var(--mol_theme_text) !important;\n}\n\n[shm_projects_codex_prompt_view] {\n\tvisibility: hidden;\n}\n"
) }